import React from "react";
import { Link } from "react-router-dom";
import { createPopper } from "@popperjs/core";
import { useHistory } from "react-router-dom";
import { logoutUser } from "components/CommanMethod/Commanmethod";

const ExpenseDropdown = () => {
  const history = useHistory();

  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  //this is the code of the logout click
  const handleLogout = () => {
    logoutUser();
    // Redirect to the login page
    history.push("/login");
  };

  // Retrieve user data from local storage
  const storedUserData = localStorage.getItem("userData");
  let userName = "";
  let userTypeId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);

    userName = userData.userName;
    userTypeId = userData.userTypeId;
  }

  return (
    <>
      <div
        className=" custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-3 lg:py-2 flex items-center text-l font-bold"
        to="/expenseDashboard"
        ref={btnDropdownRef}
        onMouseOver={(e) => {
          e.preventDefault();
          openDropdownPopover();
        }}
        onMouseLeave={(e) => {
          e.preventDefault();
          closeDropdownPopover();
        }}
      >
        Expenses{" "}
        <i
          className="fa fa-angle-down"
          aria-hidden="true"
          style={{ margin: "5px" }}
        ></i>
        <div
          ref={popoverDropdownRef}
          className={
            (dropdownPopoverShow ? "block " : "hidden ") +
            "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
          }
        >
          <span
            className={
              "text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400"
            }
          ></span>

          <Link
            to="/expenseDashboard"
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Dashboard
          </Link>
          {/* <Link
            to="/newExpenseDashboard"
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Dashboard 2
          </Link> */}

          <Link
            to="/expenses"
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Expenses
          </Link>
          {userTypeId !== 3 && (
            <Link
              to="/getExpensetype"
              className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            >
              Expense Types
            </Link>
          )}
        </div>
      </div>
      {/* <Link
        className=" custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-3 lg:py-2 flex items-center text-xs font-bold"
        to="/expenseDashboard"
        ref={btnDropdownRef}
        onMouseOver={(e) => {
          e.preventDefault();
          openDropdownPopover();
        }}
        onMouseLeave={(e) => {
          e.preventDefault();
          closeDropdownPopover();
        }}
      >
        Expenses{" "}
        <i
          className="fa fa-angle-down"
          aria-hidden="true"
          style={{ margin: "5px" }}
        ></i>
        <div
          ref={popoverDropdownRef}
          className={
            (dropdownPopoverShow ? "block " : "hidden ") +
            "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
          }
        >
          <span
            className={
              "text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400"
            }
          ></span>

          <Link
            to="/expenseDashboard"
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Dashboard
          </Link>

          <Link
            to="/expenses"
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Expenses
          </Link>
          {userTypeId !== 3 && (
            <Link
              to="/getExpensetype"
              className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            >
              Expense Types
            </Link>
          )}
        </div>
      </Link> */}
    </>
  );
};

export default ExpenseDropdown;
